import { languageList, useTranslation } from '@pancakeswap/localization'
import { Flex, IconButton, Menu as UikitMenu, MoonIcon, SunIcon, useModal } from '@pancakeswap/uikit'
import { NextLinkFromReactRouter } from '@pancakeswap/widgets-internal'
import { styled } from 'styled-components'

import USCitizenConfirmModal from 'components/Modal/USCitizenConfirmModal'
import { NetworkSwitcher } from 'components/NetworkSwitcher'
import { useCakePrice } from 'hooks/useCakePrice'
import useTheme from 'hooks/useTheme'
import { useRouter } from 'next/router'
import { useMemo } from 'react'
import { useActiveChainId } from 'hooks/useActiveChainId'
import { IdType } from 'hooks/useUserIsUsCitizenAcknowledgement'
import { BIG_ZERO } from '@pancakeswap/utils/bigNumber'
import { useMenuItems } from './hooks/useMenuItems'
import UserMenu from './UserMenu'
import { getActiveMenuItem, getActiveSubMenuItem } from './utils'

const LinkComponent = (linkProps) => {
  return <NextLinkFromReactRouter to={linkProps.href} {...linkProps} prefetch={false} />
}

const HeaderActions = styled(Flex)`
  align-items: center;
  gap: 6px;

  ${({ theme }) => theme.mediaQueries.sm} {
    gap: 8px;
  }
`

const ThemeButton = styled(IconButton)`
  width: 40px;
  height: 40px;
  min-width: 40px;
  padding: 0;
  border: 1px solid ${({ theme }) => theme.colors.cardBorder};
  border-radius: 14px;
  background: ${({ theme }) => (theme.isDark ? theme.colors.backgroundAlt : '#ffffff')};
  box-shadow: ${({ theme }) => (theme.isDark ? 'none' : '0 3px 10px rgba(16, 24, 40, 0.08)')};

  &:hover {
    background: ${({ theme }) => theme.colors.tertiary};
    opacity: 1;
    transform: translateY(-1px);
  }
`

const Menu = (props) => {
  const { chainId } = useActiveChainId()
  const { isDark, setTheme } = useTheme()
  const cakePrice = useCakePrice()
  const { currentLanguage, setLanguage, t } = useTranslation()
  const { pathname } = useRouter()
  const [onUSCitizenModalPresent] = useModal(
    <USCitizenConfirmModal title={t('MacSwap Perpetuals')} id={IdType.PERPETUALS} />,
    false,
    false,
    'usCitizenConfirmModal',
  )

  const menuItems = useMenuItems(onUSCitizenModalPresent)

  const activeMenuItem = getActiveMenuItem({ menuConfig: menuItems, pathname })
  const activeSubMenuItem = getActiveSubMenuItem({ menuItem: activeMenuItem, pathname })

  const toggleTheme = useMemo(() => {
    return () => setTheme(isDark ? 'light' : 'dark')
  }, [setTheme, isDark])

  const getFooterLinks = useMemo(() => {
    return []
  }, [])

  return (
    <>
      <UikitMenu
        linkComponent={LinkComponent}
        rightSide={
          <HeaderActions>
            <NetworkSwitcher />
            <ThemeButton
              variant="text"
              onClick={toggleTheme}
              aria-label={isDark ? t('Switch to light mode') : t('Switch to dark mode')}
              title={isDark ? t('Switch to light mode') : t('Switch to dark mode')}
            >
              {isDark ? <SunIcon width="20px" color="warning" /> : <MoonIcon width="20px" color="primary" />}
            </ThemeButton>
            <UserMenu />
          </HeaderActions>
        }
        chainId={chainId}
        isDark={isDark}
        toggleTheme={toggleTheme}
        currentLang={currentLanguage.code}
        langs={languageList}
        setLang={setLanguage}
        cakePriceUsd={cakePrice.eq(BIG_ZERO) ? undefined : cakePrice}
        links={menuItems}
        subLinks={activeMenuItem?.hideSubNav || activeSubMenuItem?.hideSubNav ? [] : activeMenuItem?.items}
        footerLinks={getFooterLinks}
        activeItem={activeMenuItem?.href}
        activeSubItem={activeSubMenuItem?.href}
        buyCakeLabel={t('Buy MACH')}
        buyCakeLink="/swap?outputCurrency=0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82&chainId=56"
        {...props}
      />
    </>
  )
}

export default Menu
